import { SubjectManager } from "../utils/subject-manager";

export const lateralMenuEventsService = new SubjectManager();
